import { useTheme } from '@mui/material';
import { FC } from 'react';
import { ReactComponent as ConnectorDiscoveredSVG } from '../../assets/icons/discovered-connector.svg';
import CustomTooltip from '../../common/components/CustomTooltip';

const ConnectorDiscovered: FC<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();
  return (
    <CustomTooltip title='System discovered'>
      <ConnectorDiscoveredSVG
        width='1.2rem'
        style={{ color: theme.palette.error.main }}
      />
    </CustomTooltip>
  );
};

export default ConnectorDiscovered;
